<script setup>
import { computed, onMounted, ref } from 'vue';

const props = defineProps({
  loading: Boolean,
  showAds: Boolean,
});

const pageWellMounted = ref(false);
const canHideLoader = ref(false);

const canShowAllMatches = computed(() => {
  return !props.loading && pageWellMounted.value;
});

onMounted(() => {
  setTimeout(() => {
    pageWellMounted.value = true;
  }, 800);
  setTimeout(() => {
    canHideLoader.value = true;
  }, 2000);
});
</script>

<template>
  <div >
    {{ showAds }}
    <LoadedAllMatches :showAds="showAds" v-if="canShowAllMatches"></LoadedAllMatches>
    <div class="asolute w-full h-full top-0" v-if="!canHideLoader">
      <LoadingAllMatches></LoadingAllMatches>
    </div>
  </div>
</template>
